<template>
  <div>
     <CRUDCriteria
       :showReset="true"
       :showSearch="false"
       :showAdditionalActions="false"
     >
     <template v-slot:criteriaRows>
        <div>
          <v-row dense class="d-flex align-end">
            <v-col cols="2">
             <ClarionDateControl  class="text-field"
              v-model="criteriaState.paymentDate"
              :label="`CC Payment Date`"
              :isIsoDate="false"
              :isToggle="false"
              @input="removeSystemDate"
              @blurred="searchByCriteria"
             />
            </v-col>
            <v-col cols="2">
             <ClarionDateControl  class="text-field"
              :label="`Business Date`"
              :isIsoDate="false"
              v-model="criteriaState.systemDate"
              :isToggle="false"
              @input="removePaymentDate"
              @blurred="searchByCriteria"
             />
            </v-col>
            <v-col cols="2">
             <ClarionDateControl  class="text-field"
              :label="`Paid Cleared Date`"
              :isIsoDate="false"
              v-model="criteriaState.paidClearedDate"
              :isRequired="false"
              @blurred="searchByCriteria"
             />
            </v-col>
            <v-col cols="2">
            <v-select id="tax-cc-criteria-payment-type"
              v-model="criteriaState.specialPaymentType"
              :items="specialPaymentType"
              item-text="description"
              item-value="name"
              label="Payment Type"
              @change="searchByCriteria"
              >
            </v-select>
          </v-col>
            <v-col cols="2">
             <v-text-field  class="text-field"
              label="Wildcard Search (amount, payer name)"
              v-uppercase=globalSettingItem.conEverythingToCaps
              v-model="criteriaState.wildcard"
              @input="wildcardSearchDelayed"
              autocomplete="off"
             ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="d-flex align-end">
            <v-col cols="2">
             <v-checkbox
              label="Show Paid Records"
              v-model="criteriaState.isShowPaidRecords"
              @change="searchByCriteria"
             ></v-checkbox>
            </v-col>
          </v-row>
        </div>
      </template>
     </CRUDCriteria>
   </div>
 </template>
<script>
import {
  mapGetters, mapState,
} from 'vuex';
import CRUDCriteria from '../../../common/base/crud-2.0/CRUDCriteria.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
// import { checkStringEmptiness } from '../../../../util/shared/vue-global';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import { SEARCH_DEBOUNCE_TIMER } from '../../common-utils/constants';

export default {
  name: 'TransactionCriteria',
  mixins: [GlobalToCaps],
  components: {
    CRUDCriteria,
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'transactionCriteria',
    },
  },
  data: () => ({
    delayTimerId: undefined,
  }),
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items', 'index']),
    ...mapState({
      specialPaymentType: (state) => state.enums.TaxCCSpecialPaymentTypeEnum || [],
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    searchByCriteria() {
      this.handleLoadCRUDList();
    },
    handleLoadCRUDList() {
      this.$emit('loadCRUDList');
    },
    wildcardSearchDelayed() {
      // cancel pending call
      clearTimeout(this.delayTimerId);
      // delay new call
      this.delayTimerId = setTimeout(async () => {
        const criteriaArgs = { searchMode: 'wildcard' };
        await this.handleLoadCRUDList(criteriaArgs);
      }, SEARCH_DEBOUNCE_TIMER);
    },
    removeSystemDate() {
      // if (!checkStringEmptiness(this.criteriaState.paymentDate)) {
      //   this.criteriaState.systemDate = null;
      // }
    },
    removePaymentDate() {
      // if (!checkStringEmptiness(this.criteriaState.systemDate)) {
      //   this.criteriaState.paymentDate = null;
      // }
    },
  },
};
</script>
